import React from "react";
import HeroSection from "../../components/home/HeroSection";
import PlanVisitSection from "../../components/home/PlanVisitSection";
import VirtualCollectionSection from "../../components/home/VirtualCollectionSection";
import AboutSection from "../../components/home/AboutSection";
import LocationSection from "../../components/home/LocationSection";

export default function Acervo() {
    return (
        <>
           <HeroSection />
           <PlanVisitSection />
           <VirtualCollectionSection />
           <AboutSection />
           <LocationSection />
        </>
    );
};